module.exports = __webpack_public_path__ + "static/media/challengingmnd.13d289d0.png";